export const toInpMetric = (metric, getHtmlElementMetadata) => {
    const { value, attribution } = metric;
    let htmlElementMetadata = {};
    if (getHtmlElementMetadata && attribution.eventEntry?.target) {
        try {
            htmlElementMetadata = getHtmlElementMetadata(attribution.eventEntry?.target);
        }
        catch (e) {
            // Ignore
        }
    }
    else {
        htmlElementMetadata = {
            compType: 'no-target-element',
        };
    }
    return {
        inpValue: Math.trunc(value),
        inpRating: metric.rating,
        inpEventType: attribution.eventType,
        inpTargetSelector: attribution.eventTarget,
        inpStartTime: attribution.eventTime
            ? Math.trunc(attribution.eventTime)
            : undefined,
        inpProcessingStart: attribution.eventEntry?.processingStart
            ? Math.trunc(attribution.eventEntry.processingStart)
            : undefined,
        inpProcessingEnd: attribution.eventEntry?.processingEnd
            ? Math.trunc(attribution.eventEntry.processingEnd)
            : undefined,
        inpInteractionId: attribution.eventEntry?.interactionId,
        inpLoadState: attribution.loadState,
        ...(htmlElementMetadata.compType && {
            inpComponentType: htmlElementMetadata.compType,
        }),
        ...(htmlElementMetadata.widgetId && {
            inpWidgetId: htmlElementMetadata.widgetId,
        }),
        ...(htmlElementMetadata.applicationId && {
            inpApplicationId: htmlElementMetadata.applicationId,
        }),
        metadata: {},
    };
};
//# sourceMappingURL=inp.js.map